/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
import {
  GlossaryFragmentDoc,
  GiftFormatsFragmentDoc,
} from '../../../ForeignProfile/gql/__generated__/Ui'
import { PhotoItemFragmentDoc } from '../../../ForeignProfile/gql/__generated__/Photos'
import { ForeignProfileFragmentDoc } from '../../../ForeignProfile/gql/__generated__/ForeignFragments'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type GQLRatingQueryVariables = Types.Exact<{
  ageFrom: Types.Scalars['Int']['input']
  ageTo: Types.Scalars['Int']['input']
  gender: Types.Scalars['String']['input']
  heightFrom?: Types.InputMaybe<Types.Scalars['Int']['input']>
  heightTo?: Types.InputMaybe<Types.Scalars['Int']['input']>
  offsetPhotoId?: Types.InputMaybe<Types.Scalars['Int']['input']>
  location?: Types.InputMaybe<Types.Scalars['String']['input']>
  coordinates?: Types.InputMaybe<Types.GQLGeoPointArg>
  limit: Types.Scalars['Int']['input']
  authorized: Types.Scalars['Boolean']['input']
  limitCountries: Types.Scalars['Int']['input']
  limitInterest: Types.Scalars['Int']['input']
  giftsLimit: Types.Scalars['Int']['input']
}>

export type GQLRatingQuery = {
  __typename?: 'Query'
  photoRating: {
    __typename?: 'PhotoRating'
    queue: {
      __typename?: 'RatingVotingPhotosSet'
      offsetPhotoId?: any | null
      photos: Array<{
        __typename?: 'RatingVotingPhoto'
        matchAhead: boolean
        featuredLiker: boolean
        photo: {
          __typename?: 'Photo'
          main: boolean
          width: number
          height: number
          portrait: boolean
          verified: boolean
          voted: boolean
          voteable: boolean
          likes: number
          liked: boolean
          photoId: any
          urls: {
            __typename?: 'PhotoUrls'
            huge: string
            square: string
            squareLarge: string
            squareSmall: string
            xHuge?: string | null
          }
          faceCenter?: {
            __typename?: 'PhotoFaceCenter'
            xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          } | null
        }
        extraPhotos: Array<{
          __typename?: 'Photo'
          main: boolean
          width: number
          height: number
          portrait: boolean
          verified: boolean
          voted: boolean
          voteable: boolean
          likes: number
          liked: boolean
          photoId: any
          urls: {
            __typename?: 'PhotoUrls'
            huge: string
            square: string
            squareLarge: string
            squareSmall: string
            xHuge?: string | null
          }
          faceCenter?: {
            __typename?: 'PhotoFaceCenter'
            xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          } | null
        }>
        requestForCommunicationMessage?:
          | {
              __typename?: 'AnswerChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'AskToFillInterestsChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'AttachedPhotoChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'GiftChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'IncognitoRequestChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'IncognitoResponseChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'InformationAboutCallChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'MissedCallChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'MutualLikeChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'PhotoCommentChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'PromoGiftChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'QuestionLikeChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'RegistrationGreetingChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'RemovedChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'RemovedForRecipientChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'StickerChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'TextChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'UnknownChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'VipPresentChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'VipProlongChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | {
              __typename?: 'WinkChatMessage'
              messageId: any
              my: boolean
              new: boolean
              postedAt: any
              text: string
            }
          | null
        photoOwner: {
          __typename?: 'PublicProfile'
          id: any
          name: string
          age?: number | null
          gender: Types.GQLGender
          zodiacSign?: Types.GQLZodiacSign | null
          isBirthdayToday?: boolean | null
          incognito: boolean
          deleted: boolean
          compatibility?: number
          online?: { __typename?: 'Online'; status: boolean } | null
          location: {
            __typename?: 'Location'
            name: string
            city: { __typename?: 'City'; id: string; name: string }
            region: { __typename?: 'Region'; id: string; name: string }
            country: { __typename?: 'Country'; id: string; name: string }
          }
          verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
          relations: {
            __typename?: 'ProfileRelations'
            winkedByMe?: boolean
            contact?: {
              __typename?: 'ChatContact'
              contactId: any
              favorite: boolean
              ignoredByThem: boolean
            } | null
            spaceTimeLocation?: {
              __typename?: 'SpaceTimeLocationRelation'
              text: any
            } | null
            distance?: { __typename?: 'Distance'; text: any } | null
          }
          photos: {
            __typename?: 'ProfilePhotos'
            photosCount: number
            photos: {
              __typename?: 'PublicPhotosConnection'
              nodes: Array<{
                __typename?: 'Photo'
                main: boolean
                width: number
                height: number
                portrait: boolean
                verified: boolean
                voted: boolean
                voteable: boolean
                likes: number
                liked: boolean
                photoId: any
                urls: {
                  __typename?: 'PhotoUrls'
                  huge: string
                  square: string
                  squareLarge: string
                  squareSmall: string
                  xHuge?: string | null
                }
                faceCenter?: {
                  __typename?: 'PhotoFaceCenter'
                  xHuge?: {
                    __typename?: 'PixelPoint'
                    x: number
                    y: number
                  } | null
                  huge?: {
                    __typename?: 'PixelPoint'
                    x: number
                    y: number
                  } | null
                } | null
              }>
              pageInfo: {
                __typename?: 'PageInfo'
                hasNextPage: boolean
                endCursor: any
              }
            }
            default?: {
              __typename?: 'Photo'
              main: boolean
              width: number
              height: number
              portrait: boolean
              verified: boolean
              voted: boolean
              voteable: boolean
              likes: number
              liked: boolean
              photoId: any
              urls: {
                __typename?: 'PhotoUrls'
                huge: string
                square: string
                squareLarge: string
                squareSmall: string
                xHuge?: string | null
              }
              faceCenter?: {
                __typename?: 'PhotoFaceCenter'
                xHuge?: {
                  __typename?: 'PixelPoint'
                  x: number
                  y: number
                } | null
                huge?: {
                  __typename?: 'PixelPoint'
                  x: number
                  y: number
                } | null
              } | null
            } | null
          }
          travelAtlas: {
            __typename?: 'PublicTravelAtlas'
            visitedCountries: {
              __typename?: 'PublicTravelAtlasVisitedCountries'
              visitedCountriesCount: number
              visitedCountries: {
                __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
                nodes: Array<{
                  __typename?: 'PublicTravelAtlasVisitedCountry'
                  date: string
                  country: {
                    __typename?: 'Country'
                    id: string
                    name: string
                    code: string
                    isoCode: string
                  }
                }>
                pageInfo: {
                  __typename?: 'PageInfo'
                  hasNextPage: boolean
                  endCursor: any
                }
              }
            }
            badges: {
              __typename?: 'PublicTravelAtlasBadges'
              badgesCount: number
              badges: {
                __typename?: 'PublicTravelAtlasBadgesConnection'
                nodes: Array<{
                  __typename?: 'PublicTravelAtlasBadge'
                  id: number
                  name: string
                  desc: string
                  image: string
                }>
                pageInfo: {
                  __typename?: 'PageInfo'
                  hasNextPage: boolean
                  endCursor: any
                }
              }
            }
          }
          vip: {
            __typename?: 'Vip'
            active: boolean
            presentVip?: {
              __typename?: 'PublicPresentVip'
              days: number
              hidden: boolean
              presenter?: {
                __typename?: 'PublicProfile'
                id: any
                name: string
                gender: Types.GQLGender
                age?: number | null
                online?: {
                  __typename?: 'Online'
                  status: boolean
                  description: any
                } | null
                verification: {
                  __typename?: 'Verification'
                  verifiedPhotos: boolean
                }
                location: { __typename?: 'Location'; name: string }
                photos: {
                  __typename?: 'ProfilePhotos'
                  default?: {
                    __typename?: 'Photo'
                    id: any
                    urls: {
                      __typename?: 'PhotoUrls'
                      squareSmall: string
                      square: string
                      squareLarge: string
                      huge: string
                    }
                  } | null
                }
              } | null
            } | null
          }
          dating: {
            __typename?: 'PublicDatingProfile'
            aboutMe: string
            lookFor: Array<Types.GQLLookFor>
            datingGoals?: Array<Types.GQLDatingGoals> | null
            knownLanguages?: Array<any> | null
            height?: number | null
            weight?: number | null
            orientation?: Types.GQLOrientation | null
            children?: Types.GQLChildren | null
            education?: Types.GQLEducation | null
            appearance?: Types.GQLAppearance | null
            constitution?: Types.GQLConstitution | null
            alcohol?: Types.GQLAlcoholAttitude | null
            smoking?: Types.GQLSmokingAttitude | null
            homeStatus?: Types.GQLHomeStatus | null
            materialStatus?: Types.GQLMaterialStatus | null
            lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
          }
          sharing?: {
            __typename?: 'PublicSharing'
            widgets?: {
              __typename?: 'PublicWidgets'
              thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
            } | null
          } | null
          interests: {
            __typename?: 'PublicInterests'
            interestsCount: number
            interests: {
              __typename?: 'PublicInterestsConnection'
              nodes: Array<{
                __typename?: 'PublicInterest'
                interestId: number
                text: string
                matchMy?: boolean | null
              }>
              pageInfo: {
                __typename?: 'PageInfo'
                hasNextPage: boolean
                endCursor: any
              }
            }
          }
          gifts: {
            __typename?: 'Gifts'
            giftsCount: number
            gifts: {
              __typename?: 'GiftsConnection'
              nodes: Array<{
                __typename?: 'Gift'
                giftId: number
                message: string
                senderHidden: boolean
                my: boolean
                senderProfile?: {
                  __typename?: 'PublicProfile'
                  id: any
                  name: string
                  age?: number | null
                  gender: Types.GQLGender
                  deleted: boolean
                  photos: {
                    __typename?: 'ProfilePhotos'
                    default?: {
                      __typename?: 'Photo'
                      id: any
                      urls: { __typename?: 'PhotoUrls'; square: string }
                    } | null
                  }
                  online?: { __typename?: 'Online'; status: boolean } | null
                  relations: {
                    __typename?: 'ProfileRelations'
                    spaceTimeLocation?: {
                      __typename?: 'SpaceTimeLocationRelation'
                      text: any
                    } | null
                  }
                  verification: {
                    __typename?: 'Verification'
                    verifiedPhotos: boolean
                  }
                } | null
                image: {
                  __typename?: 'MyGiftImage'
                  name: string
                  formats: Array<number>
                }
              }>
              pageInfo: {
                __typename?: 'PageInfo'
                endCursor: any
                hasNextPage: boolean
              }
            }
          }
          teamo?: {
            __typename?: 'PublicTeamo'
            compatibility?: number | null
            surveyResult?: Array<{
              __typename?: 'TeamoPeculiarity'
              id: number
              points: number
              title: string
              description: string
            }> | null
          } | null
        }
      }>
    }
  }
  ui: {
    __typename?: 'Ui'
    glossary: {
      __typename?: 'LexicalGlossary'
      datingProfile: {
        __typename?: 'DatingProfileLexicalDictionary'
        alcohol: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        appearance: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        children: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        constitution: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        datingGoals: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        education: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        homeStatus: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        knownLanguages: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        lookFor: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        materialStatus: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        orientation: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        smoking: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
      }
    }
    giftFormats: Array<{
      __typename?: 'GiftImageFormatType'
      formatId: number
      urlTemplate: string
      type: Types.GQLGiftImageKind
    }>
  }
}

export type GQLRatingPhotosFragment = {
  __typename?: 'RatingVotingPhotosSet'
  offsetPhotoId?: any | null
  photos: Array<{
    __typename?: 'RatingVotingPhoto'
    matchAhead: boolean
    featuredLiker: boolean
    photo: {
      __typename?: 'Photo'
      main: boolean
      width: number
      height: number
      portrait: boolean
      verified: boolean
      voted: boolean
      voteable: boolean
      likes: number
      liked: boolean
      photoId: any
      urls: {
        __typename?: 'PhotoUrls'
        huge: string
        square: string
        squareLarge: string
        squareSmall: string
        xHuge?: string | null
      }
      faceCenter?: {
        __typename?: 'PhotoFaceCenter'
        xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      } | null
    }
    extraPhotos: Array<{
      __typename?: 'Photo'
      main: boolean
      width: number
      height: number
      portrait: boolean
      verified: boolean
      voted: boolean
      voteable: boolean
      likes: number
      liked: boolean
      photoId: any
      urls: {
        __typename?: 'PhotoUrls'
        huge: string
        square: string
        squareLarge: string
        squareSmall: string
        xHuge?: string | null
      }
      faceCenter?: {
        __typename?: 'PhotoFaceCenter'
        xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      } | null
    }>
    requestForCommunicationMessage?:
      | {
          __typename?: 'AnswerChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'AskToFillInterestsChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'AttachedPhotoChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'GiftChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'IncognitoRequestChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'IncognitoResponseChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'InformationAboutCallChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'MissedCallChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'MutualLikeChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'PhotoCommentChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'PromoGiftChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'QuestionLikeChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'RegistrationGreetingChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'RemovedChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'RemovedForRecipientChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'StickerChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'TextChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'UnknownChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'VipPresentChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'VipProlongChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | {
          __typename?: 'WinkChatMessage'
          messageId: any
          my: boolean
          new: boolean
          postedAt: any
          text: string
        }
      | null
    photoOwner: {
      __typename?: 'PublicProfile'
      id: any
      name: string
      age?: number | null
      gender: Types.GQLGender
      zodiacSign?: Types.GQLZodiacSign | null
      isBirthdayToday?: boolean | null
      incognito: boolean
      deleted: boolean
      compatibility?: number
      online?: { __typename?: 'Online'; status: boolean } | null
      location: {
        __typename?: 'Location'
        name: string
        city: { __typename?: 'City'; id: string; name: string }
        region: { __typename?: 'Region'; id: string; name: string }
        country: { __typename?: 'Country'; id: string; name: string }
      }
      verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
      relations: {
        __typename?: 'ProfileRelations'
        winkedByMe?: boolean
        contact?: {
          __typename?: 'ChatContact'
          contactId: any
          favorite: boolean
          ignoredByThem: boolean
        } | null
        spaceTimeLocation?: {
          __typename?: 'SpaceTimeLocationRelation'
          text: any
        } | null
        distance?: { __typename?: 'Distance'; text: any } | null
      }
      photos: {
        __typename?: 'ProfilePhotos'
        photosCount: number
        photos: {
          __typename?: 'PublicPhotosConnection'
          nodes: Array<{
            __typename?: 'Photo'
            main: boolean
            width: number
            height: number
            portrait: boolean
            verified: boolean
            voted: boolean
            voteable: boolean
            likes: number
            liked: boolean
            photoId: any
            urls: {
              __typename?: 'PhotoUrls'
              huge: string
              square: string
              squareLarge: string
              squareSmall: string
              xHuge?: string | null
            }
            faceCenter?: {
              __typename?: 'PhotoFaceCenter'
              xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
              huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            } | null
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
        default?: {
          __typename?: 'Photo'
          main: boolean
          width: number
          height: number
          portrait: boolean
          verified: boolean
          voted: boolean
          voteable: boolean
          likes: number
          liked: boolean
          photoId: any
          urls: {
            __typename?: 'PhotoUrls'
            huge: string
            square: string
            squareLarge: string
            squareSmall: string
            xHuge?: string | null
          }
          faceCenter?: {
            __typename?: 'PhotoFaceCenter'
            xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          } | null
        } | null
      }
      travelAtlas: {
        __typename?: 'PublicTravelAtlas'
        visitedCountries: {
          __typename?: 'PublicTravelAtlasVisitedCountries'
          visitedCountriesCount: number
          visitedCountries: {
            __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
            nodes: Array<{
              __typename?: 'PublicTravelAtlasVisitedCountry'
              date: string
              country: {
                __typename?: 'Country'
                id: string
                name: string
                code: string
                isoCode: string
              }
            }>
            pageInfo: {
              __typename?: 'PageInfo'
              hasNextPage: boolean
              endCursor: any
            }
          }
        }
        badges: {
          __typename?: 'PublicTravelAtlasBadges'
          badgesCount: number
          badges: {
            __typename?: 'PublicTravelAtlasBadgesConnection'
            nodes: Array<{
              __typename?: 'PublicTravelAtlasBadge'
              id: number
              name: string
              desc: string
              image: string
            }>
            pageInfo: {
              __typename?: 'PageInfo'
              hasNextPage: boolean
              endCursor: any
            }
          }
        }
      }
      vip: {
        __typename?: 'Vip'
        active: boolean
        presentVip?: {
          __typename?: 'PublicPresentVip'
          days: number
          hidden: boolean
          presenter?: {
            __typename?: 'PublicProfile'
            id: any
            name: string
            gender: Types.GQLGender
            age?: number | null
            online?: {
              __typename?: 'Online'
              status: boolean
              description: any
            } | null
            verification: {
              __typename?: 'Verification'
              verifiedPhotos: boolean
            }
            location: { __typename?: 'Location'; name: string }
            photos: {
              __typename?: 'ProfilePhotos'
              default?: {
                __typename?: 'Photo'
                id: any
                urls: {
                  __typename?: 'PhotoUrls'
                  squareSmall: string
                  square: string
                  squareLarge: string
                  huge: string
                }
              } | null
            }
          } | null
        } | null
      }
      dating: {
        __typename?: 'PublicDatingProfile'
        aboutMe: string
        lookFor: Array<Types.GQLLookFor>
        datingGoals?: Array<Types.GQLDatingGoals> | null
        knownLanguages?: Array<any> | null
        height?: number | null
        weight?: number | null
        orientation?: Types.GQLOrientation | null
        children?: Types.GQLChildren | null
        education?: Types.GQLEducation | null
        appearance?: Types.GQLAppearance | null
        constitution?: Types.GQLConstitution | null
        alcohol?: Types.GQLAlcoholAttitude | null
        smoking?: Types.GQLSmokingAttitude | null
        homeStatus?: Types.GQLHomeStatus | null
        materialStatus?: Types.GQLMaterialStatus | null
        lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
      }
      sharing?: {
        __typename?: 'PublicSharing'
        widgets?: {
          __typename?: 'PublicWidgets'
          thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
        } | null
      } | null
      interests: {
        __typename?: 'PublicInterests'
        interestsCount: number
        interests: {
          __typename?: 'PublicInterestsConnection'
          nodes: Array<{
            __typename?: 'PublicInterest'
            interestId: number
            text: string
            matchMy?: boolean | null
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
      gifts: {
        __typename?: 'Gifts'
        giftsCount: number
        gifts: {
          __typename?: 'GiftsConnection'
          nodes: Array<{
            __typename?: 'Gift'
            giftId: number
            message: string
            senderHidden: boolean
            my: boolean
            senderProfile?: {
              __typename?: 'PublicProfile'
              id: any
              name: string
              age?: number | null
              gender: Types.GQLGender
              deleted: boolean
              photos: {
                __typename?: 'ProfilePhotos'
                default?: {
                  __typename?: 'Photo'
                  id: any
                  urls: { __typename?: 'PhotoUrls'; square: string }
                } | null
              }
              online?: { __typename?: 'Online'; status: boolean } | null
              relations: {
                __typename?: 'ProfileRelations'
                spaceTimeLocation?: {
                  __typename?: 'SpaceTimeLocationRelation'
                  text: any
                } | null
              }
              verification: {
                __typename?: 'Verification'
                verifiedPhotos: boolean
              }
            } | null
            image: {
              __typename?: 'MyGiftImage'
              name: string
              formats: Array<number>
            }
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            endCursor: any
            hasNextPage: boolean
          }
        }
      }
      teamo?: {
        __typename?: 'PublicTeamo'
        compatibility?: number | null
        surveyResult?: Array<{
          __typename?: 'TeamoPeculiarity'
          id: number
          points: number
          title: string
          description: string
        }> | null
      } | null
    }
  }>
}

export type GQLRatingFragment = {
  __typename?: 'PhotoRating'
  queue: {
    __typename?: 'RatingVotingPhotosSet'
    offsetPhotoId?: any | null
    photos: Array<{
      __typename?: 'RatingVotingPhoto'
      matchAhead: boolean
      featuredLiker: boolean
      photo: {
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      }
      extraPhotos: Array<{
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      }>
      requestForCommunicationMessage?:
        | {
            __typename?: 'AnswerChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'AskToFillInterestsChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'AttachedPhotoChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'GiftChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'IncognitoRequestChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'IncognitoResponseChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'InformationAboutCallChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'MissedCallChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'MutualLikeChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'PhotoCommentChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'PromoGiftChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'QuestionLikeChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'RegistrationGreetingChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'RemovedChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'RemovedForRecipientChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'StickerChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'TextChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'UnknownChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'VipPresentChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'VipProlongChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | {
            __typename?: 'WinkChatMessage'
            messageId: any
            my: boolean
            new: boolean
            postedAt: any
            text: string
          }
        | null
      photoOwner: {
        __typename?: 'PublicProfile'
        id: any
        name: string
        age?: number | null
        gender: Types.GQLGender
        zodiacSign?: Types.GQLZodiacSign | null
        isBirthdayToday?: boolean | null
        incognito: boolean
        deleted: boolean
        compatibility?: number
        online?: { __typename?: 'Online'; status: boolean } | null
        location: {
          __typename?: 'Location'
          name: string
          city: { __typename?: 'City'; id: string; name: string }
          region: { __typename?: 'Region'; id: string; name: string }
          country: { __typename?: 'Country'; id: string; name: string }
        }
        verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
        relations: {
          __typename?: 'ProfileRelations'
          winkedByMe?: boolean
          contact?: {
            __typename?: 'ChatContact'
            contactId: any
            favorite: boolean
            ignoredByThem: boolean
          } | null
          spaceTimeLocation?: {
            __typename?: 'SpaceTimeLocationRelation'
            text: any
          } | null
          distance?: { __typename?: 'Distance'; text: any } | null
        }
        photos: {
          __typename?: 'ProfilePhotos'
          photosCount: number
          photos: {
            __typename?: 'PublicPhotosConnection'
            nodes: Array<{
              __typename?: 'Photo'
              main: boolean
              width: number
              height: number
              portrait: boolean
              verified: boolean
              voted: boolean
              voteable: boolean
              likes: number
              liked: boolean
              photoId: any
              urls: {
                __typename?: 'PhotoUrls'
                huge: string
                square: string
                squareLarge: string
                squareSmall: string
                xHuge?: string | null
              }
              faceCenter?: {
                __typename?: 'PhotoFaceCenter'
                xHuge?: {
                  __typename?: 'PixelPoint'
                  x: number
                  y: number
                } | null
                huge?: {
                  __typename?: 'PixelPoint'
                  x: number
                  y: number
                } | null
              } | null
            }>
            pageInfo: {
              __typename?: 'PageInfo'
              hasNextPage: boolean
              endCursor: any
            }
          }
          default?: {
            __typename?: 'Photo'
            main: boolean
            width: number
            height: number
            portrait: boolean
            verified: boolean
            voted: boolean
            voteable: boolean
            likes: number
            liked: boolean
            photoId: any
            urls: {
              __typename?: 'PhotoUrls'
              huge: string
              square: string
              squareLarge: string
              squareSmall: string
              xHuge?: string | null
            }
            faceCenter?: {
              __typename?: 'PhotoFaceCenter'
              xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
              huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            } | null
          } | null
        }
        travelAtlas: {
          __typename?: 'PublicTravelAtlas'
          visitedCountries: {
            __typename?: 'PublicTravelAtlasVisitedCountries'
            visitedCountriesCount: number
            visitedCountries: {
              __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
              nodes: Array<{
                __typename?: 'PublicTravelAtlasVisitedCountry'
                date: string
                country: {
                  __typename?: 'Country'
                  id: string
                  name: string
                  code: string
                  isoCode: string
                }
              }>
              pageInfo: {
                __typename?: 'PageInfo'
                hasNextPage: boolean
                endCursor: any
              }
            }
          }
          badges: {
            __typename?: 'PublicTravelAtlasBadges'
            badgesCount: number
            badges: {
              __typename?: 'PublicTravelAtlasBadgesConnection'
              nodes: Array<{
                __typename?: 'PublicTravelAtlasBadge'
                id: number
                name: string
                desc: string
                image: string
              }>
              pageInfo: {
                __typename?: 'PageInfo'
                hasNextPage: boolean
                endCursor: any
              }
            }
          }
        }
        vip: {
          __typename?: 'Vip'
          active: boolean
          presentVip?: {
            __typename?: 'PublicPresentVip'
            days: number
            hidden: boolean
            presenter?: {
              __typename?: 'PublicProfile'
              id: any
              name: string
              gender: Types.GQLGender
              age?: number | null
              online?: {
                __typename?: 'Online'
                status: boolean
                description: any
              } | null
              verification: {
                __typename?: 'Verification'
                verifiedPhotos: boolean
              }
              location: { __typename?: 'Location'; name: string }
              photos: {
                __typename?: 'ProfilePhotos'
                default?: {
                  __typename?: 'Photo'
                  id: any
                  urls: {
                    __typename?: 'PhotoUrls'
                    squareSmall: string
                    square: string
                    squareLarge: string
                    huge: string
                  }
                } | null
              }
            } | null
          } | null
        }
        dating: {
          __typename?: 'PublicDatingProfile'
          aboutMe: string
          lookFor: Array<Types.GQLLookFor>
          datingGoals?: Array<Types.GQLDatingGoals> | null
          knownLanguages?: Array<any> | null
          height?: number | null
          weight?: number | null
          orientation?: Types.GQLOrientation | null
          children?: Types.GQLChildren | null
          education?: Types.GQLEducation | null
          appearance?: Types.GQLAppearance | null
          constitution?: Types.GQLConstitution | null
          alcohol?: Types.GQLAlcoholAttitude | null
          smoking?: Types.GQLSmokingAttitude | null
          homeStatus?: Types.GQLHomeStatus | null
          materialStatus?: Types.GQLMaterialStatus | null
          lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
        }
        sharing?: {
          __typename?: 'PublicSharing'
          widgets?: {
            __typename?: 'PublicWidgets'
            thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
          } | null
        } | null
        interests: {
          __typename?: 'PublicInterests'
          interestsCount: number
          interests: {
            __typename?: 'PublicInterestsConnection'
            nodes: Array<{
              __typename?: 'PublicInterest'
              interestId: number
              text: string
              matchMy?: boolean | null
            }>
            pageInfo: {
              __typename?: 'PageInfo'
              hasNextPage: boolean
              endCursor: any
            }
          }
        }
        gifts: {
          __typename?: 'Gifts'
          giftsCount: number
          gifts: {
            __typename?: 'GiftsConnection'
            nodes: Array<{
              __typename?: 'Gift'
              giftId: number
              message: string
              senderHidden: boolean
              my: boolean
              senderProfile?: {
                __typename?: 'PublicProfile'
                id: any
                name: string
                age?: number | null
                gender: Types.GQLGender
                deleted: boolean
                photos: {
                  __typename?: 'ProfilePhotos'
                  default?: {
                    __typename?: 'Photo'
                    id: any
                    urls: { __typename?: 'PhotoUrls'; square: string }
                  } | null
                }
                online?: { __typename?: 'Online'; status: boolean } | null
                relations: {
                  __typename?: 'ProfileRelations'
                  spaceTimeLocation?: {
                    __typename?: 'SpaceTimeLocationRelation'
                    text: any
                  } | null
                }
                verification: {
                  __typename?: 'Verification'
                  verifiedPhotos: boolean
                }
              } | null
              image: {
                __typename?: 'MyGiftImage'
                name: string
                formats: Array<number>
              }
            }>
            pageInfo: {
              __typename?: 'PageInfo'
              endCursor: any
              hasNextPage: boolean
            }
          }
        }
        teamo?: {
          __typename?: 'PublicTeamo'
          compatibility?: number | null
          surveyResult?: Array<{
            __typename?: 'TeamoPeculiarity'
            id: number
            points: number
            title: string
            description: string
          }> | null
        } | null
      }
    }>
  }
}

export type GQLRequestMessageForCommunicationFragment = {
  __typename?: 'RatingVotingPhoto'
  requestForCommunicationMessage?:
    | {
        __typename?: 'AnswerChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'AskToFillInterestsChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'AttachedPhotoChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'GiftChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'IncognitoRequestChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'IncognitoResponseChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'InformationAboutCallChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'MissedCallChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'MutualLikeChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'PhotoCommentChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'PromoGiftChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'QuestionLikeChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'RegistrationGreetingChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'RemovedChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'RemovedForRecipientChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'StickerChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'TextChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'UnknownChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'VipPresentChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'VipProlongChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | {
        __typename?: 'WinkChatMessage'
        messageId: any
        my: boolean
        new: boolean
        postedAt: any
        text: string
      }
    | null
}

export type GQLRatingMainPhotoFragment = {
  __typename?: 'RatingVotingPhoto'
  photo: {
    __typename?: 'Photo'
    main: boolean
    width: number
    height: number
    portrait: boolean
    verified: boolean
    voted: boolean
    voteable: boolean
    likes: number
    liked: boolean
    photoId: any
    urls: {
      __typename?: 'PhotoUrls'
      huge: string
      square: string
      squareLarge: string
      squareSmall: string
      xHuge?: string | null
    }
    faceCenter?: {
      __typename?: 'PhotoFaceCenter'
      xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
    } | null
  }
  extraPhotos: Array<{
    __typename?: 'Photo'
    main: boolean
    width: number
    height: number
    portrait: boolean
    verified: boolean
    voted: boolean
    voteable: boolean
    likes: number
    liked: boolean
    photoId: any
    urls: {
      __typename?: 'PhotoUrls'
      huge: string
      square: string
      squareLarge: string
      squareSmall: string
      xHuge?: string | null
    }
    faceCenter?: {
      __typename?: 'PhotoFaceCenter'
      xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
    } | null
  }>
}

export type GQLRatingProfileFragment = {
  __typename?: 'RatingVotingPhoto'
  photoOwner: {
    __typename?: 'PublicProfile'
    id: any
    name: string
    age?: number | null
    gender: Types.GQLGender
    zodiacSign?: Types.GQLZodiacSign | null
    isBirthdayToday?: boolean | null
    incognito: boolean
    deleted: boolean
    compatibility?: number
    online?: { __typename?: 'Online'; status: boolean } | null
    location: {
      __typename?: 'Location'
      name: string
      city: { __typename?: 'City'; id: string; name: string }
      region: { __typename?: 'Region'; id: string; name: string }
      country: { __typename?: 'Country'; id: string; name: string }
    }
    verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
    relations: {
      __typename?: 'ProfileRelations'
      winkedByMe?: boolean
      contact?: {
        __typename?: 'ChatContact'
        contactId: any
        favorite: boolean
        ignoredByThem: boolean
      } | null
      spaceTimeLocation?: {
        __typename?: 'SpaceTimeLocationRelation'
        text: any
      } | null
      distance?: { __typename?: 'Distance'; text: any } | null
    }
    photos: {
      __typename?: 'ProfilePhotos'
      photosCount: number
      photos: {
        __typename?: 'PublicPhotosConnection'
        nodes: Array<{
          __typename?: 'Photo'
          main: boolean
          width: number
          height: number
          portrait: boolean
          verified: boolean
          voted: boolean
          voteable: boolean
          likes: number
          liked: boolean
          photoId: any
          urls: {
            __typename?: 'PhotoUrls'
            huge: string
            square: string
            squareLarge: string
            squareSmall: string
            xHuge?: string | null
          }
          faceCenter?: {
            __typename?: 'PhotoFaceCenter'
            xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          } | null
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
      default?: {
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      } | null
    }
    travelAtlas: {
      __typename?: 'PublicTravelAtlas'
      visitedCountries: {
        __typename?: 'PublicTravelAtlasVisitedCountries'
        visitedCountriesCount: number
        visitedCountries: {
          __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
          nodes: Array<{
            __typename?: 'PublicTravelAtlasVisitedCountry'
            date: string
            country: {
              __typename?: 'Country'
              id: string
              name: string
              code: string
              isoCode: string
            }
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
      badges: {
        __typename?: 'PublicTravelAtlasBadges'
        badgesCount: number
        badges: {
          __typename?: 'PublicTravelAtlasBadgesConnection'
          nodes: Array<{
            __typename?: 'PublicTravelAtlasBadge'
            id: number
            name: string
            desc: string
            image: string
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
    }
    vip: {
      __typename?: 'Vip'
      active: boolean
      presentVip?: {
        __typename?: 'PublicPresentVip'
        days: number
        hidden: boolean
        presenter?: {
          __typename?: 'PublicProfile'
          id: any
          name: string
          gender: Types.GQLGender
          age?: number | null
          online?: {
            __typename?: 'Online'
            status: boolean
            description: any
          } | null
          verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
          location: { __typename?: 'Location'; name: string }
          photos: {
            __typename?: 'ProfilePhotos'
            default?: {
              __typename?: 'Photo'
              id: any
              urls: {
                __typename?: 'PhotoUrls'
                squareSmall: string
                square: string
                squareLarge: string
                huge: string
              }
            } | null
          }
        } | null
      } | null
    }
    dating: {
      __typename?: 'PublicDatingProfile'
      aboutMe: string
      lookFor: Array<Types.GQLLookFor>
      datingGoals?: Array<Types.GQLDatingGoals> | null
      knownLanguages?: Array<any> | null
      height?: number | null
      weight?: number | null
      orientation?: Types.GQLOrientation | null
      children?: Types.GQLChildren | null
      education?: Types.GQLEducation | null
      appearance?: Types.GQLAppearance | null
      constitution?: Types.GQLConstitution | null
      alcohol?: Types.GQLAlcoholAttitude | null
      smoking?: Types.GQLSmokingAttitude | null
      homeStatus?: Types.GQLHomeStatus | null
      materialStatus?: Types.GQLMaterialStatus | null
      lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
    }
    sharing?: {
      __typename?: 'PublicSharing'
      widgets?: {
        __typename?: 'PublicWidgets'
        thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
      } | null
    } | null
    interests: {
      __typename?: 'PublicInterests'
      interestsCount: number
      interests: {
        __typename?: 'PublicInterestsConnection'
        nodes: Array<{
          __typename?: 'PublicInterest'
          interestId: number
          text: string
          matchMy?: boolean | null
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    gifts: {
      __typename?: 'Gifts'
      giftsCount: number
      gifts: {
        __typename?: 'GiftsConnection'
        nodes: Array<{
          __typename?: 'Gift'
          giftId: number
          message: string
          senderHidden: boolean
          my: boolean
          senderProfile?: {
            __typename?: 'PublicProfile'
            id: any
            name: string
            age?: number | null
            gender: Types.GQLGender
            deleted: boolean
            photos: {
              __typename?: 'ProfilePhotos'
              default?: {
                __typename?: 'Photo'
                id: any
                urls: { __typename?: 'PhotoUrls'; square: string }
              } | null
            }
            online?: { __typename?: 'Online'; status: boolean } | null
            relations: {
              __typename?: 'ProfileRelations'
              spaceTimeLocation?: {
                __typename?: 'SpaceTimeLocationRelation'
                text: any
              } | null
            }
            verification: {
              __typename?: 'Verification'
              verifiedPhotos: boolean
            }
          } | null
          image: {
            __typename?: 'MyGiftImage'
            name: string
            formats: Array<number>
          }
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          endCursor: any
          hasNextPage: boolean
        }
      }
    }
    teamo?: {
      __typename?: 'PublicTeamo'
      compatibility?: number | null
      surveyResult?: Array<{
        __typename?: 'TeamoPeculiarity'
        id: number
        points: number
        title: string
        description: string
      }> | null
    } | null
  }
}

export const RatingMainPhotoFragmentDoc = gql`
  fragment RatingMainPhoto on RatingVotingPhoto {
    photo {
      ...PhotoItem
    }
    extraPhotos {
      ...PhotoItem
    }
  }
  ${PhotoItemFragmentDoc}
`
export const RequestMessageForCommunicationFragmentDoc = gql`
  fragment RequestMessageForCommunication on RatingVotingPhoto {
    requestForCommunicationMessage @include(if: $authorized) {
      messageId
      my
      new
      postedAt
      text
    }
  }
`
export const RatingProfileFragmentDoc = gql`
  fragment RatingProfile on RatingVotingPhoto {
    photoOwner {
      ...ForeignProfile
    }
  }
  ${ForeignProfileFragmentDoc}
`
export const RatingPhotosFragmentDoc = gql`
  fragment RatingPhotos on RatingVotingPhotosSet {
    photos {
      ...RatingMainPhoto
      ...RequestMessageForCommunication
      ...RatingProfile
      matchAhead
      featuredLiker
    }
    offsetPhotoId
  }
  ${RatingMainPhotoFragmentDoc}
  ${RequestMessageForCommunicationFragmentDoc}
  ${RatingProfileFragmentDoc}
`
export const RatingFragmentDoc = gql`
  fragment Rating on PhotoRating {
    queue(
      ageFrom: $ageFrom
      ageTo: $ageTo
      gender: $gender
      heightFrom: $heightFrom
      heightTo: $heightTo
      location: $location
      coordinates: $coordinates
      offsetPhotoId: $offsetPhotoId
      limit: $limit
    ) {
      ...RatingPhotos
    }
  }
  ${RatingPhotosFragmentDoc}
`
export const RatingDocument = gql`
  query Rating(
    $ageFrom: Int!
    $ageTo: Int!
    $gender: String!
    $heightFrom: Int
    $heightTo: Int
    $offsetPhotoId: Int
    $location: String
    $coordinates: GeoPointArg
    $limit: Int!
    $authorized: Boolean!
    $limitCountries: Int!
    $limitInterest: Int!
    $giftsLimit: Int!
  ) {
    photoRating {
      ...Rating
    }
    ui {
      ...Glossary
      ...GiftFormats
    }
  }
  ${RatingFragmentDoc}
  ${GlossaryFragmentDoc}
  ${GiftFormatsFragmentDoc}
`

/**
 * __useRatingQuery__
 *
 * To run a query within a React component, call `useRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatingQuery({
 *   variables: {
 *      ageFrom: // value for 'ageFrom'
 *      ageTo: // value for 'ageTo'
 *      gender: // value for 'gender'
 *      heightFrom: // value for 'heightFrom'
 *      heightTo: // value for 'heightTo'
 *      offsetPhotoId: // value for 'offsetPhotoId'
 *      location: // value for 'location'
 *      coordinates: // value for 'coordinates'
 *      limit: // value for 'limit'
 *      authorized: // value for 'authorized'
 *      limitCountries: // value for 'limitCountries'
 *      limitInterest: // value for 'limitInterest'
 *      giftsLimit: // value for 'giftsLimit'
 *   },
 * });
 */
export function useRatingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQLRatingQuery,
    GQLRatingQueryVariables
  > &
    ({ variables: GQLRatingQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQLRatingQuery, GQLRatingQueryVariables>(
    RatingDocument,
    options
  )
}
export function useRatingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQLRatingQuery,
    GQLRatingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQLRatingQuery, GQLRatingQueryVariables>(
    RatingDocument,
    options
  )
}
export function useRatingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GQLRatingQuery, GQLRatingQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GQLRatingQuery, GQLRatingQueryVariables>(
    RatingDocument,
    options
  )
}
export type RatingQueryHookResult = ReturnType<typeof useRatingQuery>
export type RatingLazyQueryHookResult = ReturnType<typeof useRatingLazyQuery>
export type RatingSuspenseQueryHookResult = ReturnType<
  typeof useRatingSuspenseQuery
>
export type RatingQueryResult = Apollo.QueryResult<
  GQLRatingQuery,
  GQLRatingQueryVariables
>
